import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
});

// Normalize FastAPI errors (string, list of {msg}, or object) into a string.
export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || 'Something went wrong';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(' ');
    if (typeof detail === 'object' && typeof detail.msg === 'string') return detail.msg;
    return String(detail);
}

// Human-readable byte formatter.
export function fmtBytes(bytes) {
    if (bytes == null || Number.isNaN(bytes)) return '—';
    if (bytes === 0) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
    return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 2)} ${units[i]}`;
}

export function fmtDate(iso) {
    if (!iso) return '—';
    try {
        return new Date(iso).toLocaleString(undefined, {
            year: 'numeric', month: 'short', day: '2-digit',
            hour: '2-digit', minute: '2-digit',
        });
    } catch {
        return iso;
    }
}

export function fileKind(name) {
    const ext = (name || '').toLowerCase().split('.').pop();
    if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'svg', 'bmp'].includes(ext)) return 'image';
    if (['mp4', 'webm', 'mov', 'mkv'].includes(ext)) return 'video';
    if (['mp3', 'wav', 'ogg', 'flac', 'aac'].includes(ext)) return 'audio';
    if (ext === 'pdf') return 'pdf';
    if (['txt', 'json', 'xml', 'csv', 'md', 'log', 'yml', 'yaml'].includes(ext)) return 'text';
    return 'other';
}
